// extracted by mini-css-extract-plugin
export default {"searchBtn":"SearchBtn_searchBtn__qgXXy","h40":"SearchBtn_h40__S5Cxq","dark":"SearchBtn_dark__JNTLr"};